import { Flex } from "@mantine/core";
import { type UseFieldArrayReturn } from "react-hook-form";
import { type IOzoneForm } from "src/pages/Settings/YachtSetup/OzoneDepletingSubstances/OzoneDepletingSubstances.types";

import OzoneItem from "./OzoneItem";

type Props = Omit<UseFieldArrayReturn<IOzoneForm>, "append">;

const OzoneList = ({ fields, remove }: Props) => {
  return (
    <Flex w="100%" direction="column" align="center" mt="md">
      {fields.map((item, index) => (
        <OzoneItem
          key={item.id}
          id={`ozones.${index}`}
          remove={() => remove(index)}
        />
      ))}
    </Flex>
  );
};

export default OzoneList;
